import React from 'react'

export function Battlefield({ className = '' }) {
  return (
    <svg
      viewBox="0 0 1200 600"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="bf-skyGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1a8cff" />
          <stop offset="40%" stopColor="#4facfe" />
          <stop offset="100%" stopColor="#a1e4ff" />
        </linearGradient>
        <linearGradient id="bf-sunRay" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="bf-mountainBack" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#63b3ed" />
          <stop offset="100%" stopColor="#81e6d9" />
        </linearGradient>
        <linearGradient id="bf-mountainMid" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3182ce" />
          <stop offset="100%" stopColor="#38b2ac" />
        </linearGradient>
        <linearGradient id="bf-mountainFront" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2c7a7b" />
          <stop offset="100%" stopColor="#22543d" />
        </linearGradient>
        <linearGradient id="bf-dirtGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5c3a21" />
          <stop offset="40%" stopColor="#4a2b14" />
          <stop offset="100%" stopColor="#2d1808" />
        </linearGradient>
        <linearGradient id="bf-grassGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#68d35c" />
          <stop offset="50%" stopColor="#48bb3c" />
          <stop offset="100%" stopColor="#2f8f24" />
        </linearGradient>
      </defs>

      {/* Sky Background */}
      <rect width="1200" height="600" fill="url(#bf-skyGrad)" />

      {/* God Rays */}
      <g fill="url(#bf-sunRay)">
        <polygon points="0,0 300,0 150,600 -100,600" />
        <polygon points="400,0 600,0 800,600 500,600" />
        <polygon points="900,0 1200,0 1400,600 1100,600" />
      </g>

      {/* Background Mountains (Layer 1 - Farthest) */}
      <path
        d="M-100 600 L150 300 L300 450 L500 250 L750 450 L950 200 L1300 600 Z"
        fill="url(#bf-mountainBack)"
        opacity="0.6"
      />

      {/* Background Mountains (Layer 2 - Mid) */}
      <path
        d="M-50 600 L250 350 L450 500 L650 300 L900 550 L1100 350 L1250 600 Z"
        fill="url(#bf-mountainMid)"
        opacity="0.8"
      />

      {/* Background Mountains (Layer 3 - Front/Hills) */}
      <path
        d="M-20 600 Q 150 450 350 550 T 750 500 T 1220 600 Z"
        fill="url(#bf-mountainFront)"
      />

      {/* Distant Waterfall */}
      <path d="M640 310 L660 310 L655 450 L645 450 Z" fill="#e2e8f0" opacity="0.7" />
      <path d="M645 450 Q 650 470 665 460" stroke="#e2e8f0" strokeWidth="4" fill="none" opacity="0.7" />

      {/* MAIN PLATFORM */}
      <g transform="translate(200, 420)">
        {/* Deep Dirt / Roots */}
        <path d="M60 0 L740 0 L780 60 L720 140 L650 180 L550 150 L450 190 L350 160 L250 180 L150 140 L80 170 L20 60 Z" fill="url(#bf-dirtGrad)" />
        
        {/* Grass Base */}
        <path d="M40 0 L760 0 L770 30 L740 45 L650 35 L550 45 L450 35 L350 45 L250 35 L150 45 L60 35 L30 30 Z" fill="url(#bf-grassGrad)" />
        
        {/* Grass Edge Highlight */}
        <path d="M40 0 L760 0" stroke="#86efac" strokeWidth="4" fill="none" strokeLinecap="round" />
      </g>

      {/* LEFT FLOATING PLATFORM */}
      <g transform="translate(180, 260)">
        <path d="M20 0 L220 0 L240 20 L210 50 L150 60 L90 45 L40 55 L0 20 Z" fill="url(#bf-dirtGrad)" />
        <path d="M15 0 L225 0 L235 15 L210 25 L150 20 L90 25 L40 20 L5 15 Z" fill="url(#bf-grassGrad)" />
        <path d="M15 0 L225 0" stroke="#86efac" strokeWidth="3" fill="none" strokeLinecap="round" />
      </g>

      {/* RIGHT FLOATING PLATFORM */}
      <g transform="translate(780, 260)">
        <path d="M20 0 L220 0 L240 20 L210 50 L150 60 L90 45 L40 55 L0 20 Z" fill="url(#bf-dirtGrad)" />
        <path d="M15 0 L225 0 L235 15 L210 25 L150 20 L90 25 L40 20 L5 15 Z" fill="url(#bf-grassGrad)" />
        <path d="M15 0 L225 0" stroke="#86efac" strokeWidth="3" fill="none" strokeLinecap="round" />
      </g>

      {/* TOP CENTER FLOATING PLATFORM */}
      <g transform="translate(480, 120)">
        <path d="M20 0 L220 0 L240 20 L210 40 L150 50 L90 35 L40 45 L0 20 Z" fill="url(#bf-dirtGrad)" />
        <path d="M15 0 L225 0 L235 15 L210 20 L150 15 L90 20 L40 15 L5 15 Z" fill="url(#bf-grassGrad)" />
        <path d="M15 0 L225 0" stroke="#86efac" strokeWidth="3" fill="none" strokeLinecap="round" />
      </g>
    </svg>
  )
}
